<template>
  <div
      v-if="!intro.closed && this.intro.fullName && show"
      :class="[hasScrolled || this.isQuestionnaire ? 'show' : 'hide']"
      style="padding: 0"
  >
    <v-snackbar
        v-model="snackbar"
        :bottom="bottom"
        :right="right"
        :timeout="timeout"
        color="white"
        width="320"
    >
      <div>
        <v-card color="white" elevation="0" height="400" width="320">
          <template slot="progress">
            <v-progress-linear
                color="deep-purple"
                height="10"
                indeterminate
            ></v-progress-linear>
          </template>
          <v-card-title
              class="justify-end"
              style="padding-top: 4px; padding-bottom: 4px"
          >
            <v-btn
                color="deep-purple lighten-2"
                icon
                @click="
                () => {
                  this.intro.closed = true;
                }
              "
            >
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-title
              class="justify-center"
              style="padding-top: 4px; padding-bottom: 4px"
          >
            <v-avatar size="120">
              <img :alt="intro.fullName" :src="intro.photoURL?intro.photoURL:'/images/Blank-Avatar.jpg'"/>
            </v-avatar>
          </v-card-title>
          <v-card-title class="justify-center py-0"
          ><span class="black--text">{{ intro.fullName }}</span></v-card-title>
          <v-card-text class="black--text">
            <v-layout justify-center class="justify-center">
              <span><strong>{{ intro.jobTitle }}</strong></span>
            </v-layout>
            <span
            >Employer number: <strong>{{ intro.employeeID }}</strong></span
            ><br/>
            <span
            >Email: <strong>{{ intro.email }}</strong></span
            ><br/>
            <span
            >Phone : <strong>{{ intro.phone }}</strong></span
            ><br/>
            <span>Gender : <strong>{{ intro.gender }}</strong></span
            ><br/>
            <span>Date of Birth : <strong>{{ intro.birthDate }}</strong></span
            ><br/>
            <span>
              Age : <strong>{{
                Math.floor((new Date() - new Date(intro.birthDate)) / (1000 * 3600 * 24 * 365))
              }}</strong></span
            ><br/>
            <span>Performance Score : {{ intro.averageScore }}</span>
          </v-card-text>
        </v-card>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "ihris-practitioner-intro",
  props: ["slotProps", "isQuestionnaire", "position"],
  data: function () {
    return {
      intro: {
        fullName: "",
        jobTitle: "",
        photoURL: "",
        birthDate: "",
        gender: "",
        employeeID: "",
        closed: false,
        emil: "",
        phone: "",
        averageScore:""
      },
      hasScrolled: false,
      snackbar: true,
      timeout: -1,
      bottom: true,
      right: true,
      show:true,
    };
  },
  components: {},
  mounted() {
    if (!this.isQuestionnaire) {
      window.addEventListener("scroll", this.handleScroll);
    } else {
      window.removeEventListener("scroll", this.handleScroll);
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    slotProps: {
      handler() {
        if (!this.lockWatch) {
          this.setupData();
        }
      },
      deep: true,
    },
  },
  methods: {
    setupData() {
      if(this.slotProps.source.path !== "Practitioner"){
        this.show = false
      }
      console.log("343434", )
      if (
          this.slotProps &&
          this.slotProps.source &&
          this.slotProps.source.data
      ) {
        let practitioner = this.slotProps.source.data;
        let title = ""
        if (practitioner && practitioner.name&&practitioner.name[0].prefix && practitioner.name[0].prefix.length) {
          title = practitioner.name[0].prefix[0]
        }
        let firstName = practitioner.name ? practitioner.name[0].given[0] : "";
        let extensions = practitioner.extension.find(
            (x) =>
                x.url ===
                "http://ihris.org/fhir/StructureDefinition/ihris-practitioner-familynames"
        );

        extensions = extensions ? extensions.extension : [];
        let fatherName = extensions?.filter((ext) => ext.url === "fathers")?.[0]?.valueString;
        let grandFatherLastName = extensions?.filter(
            (ext) => ext.url === "grandfatherslastname"
        )?.[0]?.valueString;
        this.intro.fullName = `${title} ${firstName} ${fatherName} ${grandFatherLastName}`;
        this.intro.email = practitioner.extension?practitioner.extension.find(x => x.url === "http://ihris.org/fhir/StructureDefinition/ihris-personal-information-email")?.valueString:''
        this.intro.phone = practitioner.extension?practitioner.extension.find(x => x.url === "http://ihris.org/fhir/StructureDefinition/ihris-personal-information-phone")?.valueString:'';
        this.intro.jobTitle = this.slotProps.position;
        this.intro.gender = practitioner?.gender;
        this.intro.birthDate = practitioner?.birthDate;

        this.intro.employeeID = practitioner?.identifier
            ? practitioner?.identifier[0]?.value
            : "";

        let photo = "";
        if (practitioner.photo) photo = practitioner?.photo[0];

        if (photo.data && photo.contentType) {
          let dataURL = "data:" + photo.contentType + ";base64," + photo.data;
          fetch(dataURL)
              .then((res) => res.blob())
              .then((blob) => {
                this.intro.photoURL = URL.createObjectURL(blob);
                //URL.revokeObjectURL(this.photoURL)
              })
              .catch((e) => {
                console.log("Failed to get data from base64.", e);
              });
        }
        let userId = this.$route.params.id;
        let performanceUrl = `/fhir/Basic?_profile=http://ihris.org/fhir/StructureDefinition/ihris-basic-performance&practitioner=${userId}`;
        fetch(performanceUrl)
            .then((res) => res.json())
            .then((res) => {
              if (res.entry && res.entry?.length > 0) {
                let result = [];
                res.entry.map((data) => {
                  let res = {};
                  if (data.resource) {
                    let performaceResult = data.resource.extension.find(
                        (x) =>
                            x.url ===
                            "http://ihris.org/fhir/StructureDefinition/ihris-performance"
                    );
                    let performaceType = performaceResult.extension.find(
                        (x) => x.url === "performanceType"
                    );
                    let performacePeriod = performaceResult.extension.find(
                        (x) => x.url === "period"
                    );
                    let performaceScore = performaceResult.extension.find(
                        (x) => x.url === "score"
                    );
                    if (performaceType) {
                      res.type = performaceType.valueCoding.code;
                    }
                    if (performacePeriod) {
                      res.period = performacePeriod.valuePeriod;
                      res.year = new Date(
                          performacePeriod.valuePeriod.end
                      ).getFullYear();
                    }
                    if (performaceScore) {
                      res.score = performaceScore.valueDecimal;
                    }
                    result.push(res);
                  }
                });

                let data = result.sort(
                    (a, b) => new Date(a.period.end) - new Date(b.period.end)
                );



                if (data?.length > 0) {
                  if (data[0].type === "biannual") {
                    if (
                        data?.length > 1 &&
                        data[1].type === "biannual" &&
                        data[0].year === data[1].year
                    ) {
                      let average = (data[0].score + data[1].score) / 2;

                      this.intro.averageScore = `${average} Average score (${data[0].type} average score for year ${data[0].year})`;
                    } else {
                      this.intro.averageScore = `${data[0].score} (${data[0].type} score for period ${data[0].period.start} to ${data[0].period.end})`;
                    }
                  } else {
                    this.intro.averageScore = `${data[0].score} (${data[0].type} score for period ${data[0].period.start} to ${data[0].period.end})`;
                  }
                }
              }else {
                this.intro.averageScore = "No performance data is available for this practitioner";
              }
            })
            .catch((e) => {
              console.log("Failed to get data from base64.", e);
            });
      }
    },
    handleScroll() {
      this.hasScrolled = window.top.scrollY >= 100;
    },
  },
};
</script>

<style scoped>
.ihris-intro-container {
  display: flex;
  flex-direction: row;
  position: fixed;
  background-color: #d06f1a;
  width: 40vw;
  z-index: 2;
  top: 20%;
  color: #fff;
  font-size: smaller;
  margin-top: 10vm;
  padding: 5px 5px;
  border-radius: 0 0 10px 10px;
  left: 50%;
  transform: translate(-50%, -50%);
}
.ihris-intro {
  display: flex;
  flex-direction: column;
  padding: 5px;
}

.hide {
  opacity: 0;
}
.show {
  opacity: 1;
}
.photo {
  max-width: 30%;
}
.hide {
  opacity: 0;
}

.show {
  opacity: 1;
}
</style>
